import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { MultiSelectInput } from '../move_me/MultiSelectInput';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';

// type RffFieldProps = {
//   validate?: FieldValidator;
//   name: string;
// };

// type react-final-formBaseFieldProps = {} & RffFieldProps &
//   Pick<React.ComponentProps<typeof FormGroup>, 'label' | 'labelFor'>;

type Props = {
  onChange?: (val: string[] | number[]) => void;
  onBlur?: (val: string[] | number[]) => void;
} & VFFieldProps<React.ComponentProps<typeof MultiSelectInput>>;
export const MultiSelectField: React.FC<Props> = ({
  name,
  validate,
  label,
  onChange: $onChange,
  onBlur: $onBlur,
  className,
  disabled,
  required,
  ...other
}) => {
  return (
    <FormItem
      name={name}
      className={className}
      label={label}
      required={required}
      disabled={disabled}
    >
      <Field name={name} validate={validate}>
        {({ input: { value, onChange } }: FieldRenderProps<any>) => (
          // <FormGroup label={label} labelFor={name}>
          <MultiSelectInput
            fill
            value={value}
            onChange={(value) => {
              onChange({ target: { name, value: value } });
              $onChange && $onChange(value);
            }}
            onBlur={(value) => {
              $onBlur && $onBlur(value);
            }}
            {...other}
            disabled={disabled}
          />
          // </FormGroup>
        )}
      </Field>
    </FormItem>
  );
};
